import Vue from 'vue'
import VueRouter from 'vue-router'
const Dashboard = () => import('@/pages/Dashboard')
const Documentation = () => import('@/pages/Documentation')
const Forgot = () => import('@/pages/Forgot')
const Confirm = () => import('@/pages/shop/Confirm')
const Login = () => import('@/pages/Login')
const ShopCart = () => import('@/pages/shop/ShopCart')
const ShopCartOndemand = () => import('@/pages/shop/ShopCartOndemand')
const Downgrade = () => import('@/pages/shop/Downgrade')
const Invoice = () => import('@/pages/billing/Invoice')
const Order = () => import('@/pages/billing/Order')
const Billing = () => import('@/pages/Billing')
const Playground = () => import('@/pages/Playground')
const Workers = () => import('@/pages/Workers')
const Statistics = () => import('@/pages/Statistics')
const Register = () => import('@/pages/Register')
const Settings = () => import('@/pages/Settings')
const Shop = () => import('@/pages/Shop')
const UserEditor = () => import('@/pages/UserEditor')
const UserManager = () => import('@/pages/UserManager')
const ShopValidate = () => import('@/pages/shop/ShopValidate')
const ShopValidateOndemand = () => import('@/pages/shop/ShopValidateOndemand')
const ConfirmOndemand = () => import('@/pages/shop/ConfirmOndemand')

Vue.use(VueRouter)

export default new VueRouter({
  mode: 'history',
  routes: [
    { path: '/documentation', components: { default: Documentation, out: Login } },
    { path: '/playground', components: { default: Playground, out: Login } },
    { path: '/workers', components: { default: Workers, out: Login } },
    { path: '/statistics', components: { default: Statistics, out: Login } },
    { path: '/settings', components: { default: Settings, out: Login } },
    { path: '/shop', components: { default: Shop, out: Login } },
    { path: '/shop/validate', components: { default: ShopValidate, out: Login } },
    { path: '/shop/cart', components: { default: ShopCart, out: Login } },
    { path: '/shop/ondemand/validate', components: { default: ShopValidateOndemand, out: Login } },
    { path: '/shop/ondemand/cart', components: { default: ShopCartOndemand, out: Login } },
    { path: '/shop/ondemand/confirm', components: { default: ConfirmOndemand, out: Login } },
    { path: '/shop/confirm/:id', components: { default: Confirm, out: Login } },
    { path: '/shop/downgrade', components: { default: Downgrade, out: Login } },
    { path: '/users', components: { default: UserManager, out: Login } },
    { path: '/usereditor/:id', components: { default: UserEditor, out: Login } },
    { path: '/billing', components: { default: Billing, out: Login } },
    { path: '/order/:id', components: { default: Order, out: Login } },
    { path: '/invoice/:id', components: { default: Invoice, out: Login } },
    { path: '/', components: { default: Dashboard, out: Login }, alias: '/home' },
    { path: '/register', components: { default: Dashboard, out: Register } },
    { path: '/forgot', components: { default: Dashboard, out: Forgot } },
    { path: '*', redirect: '/' }
  ]
})
